import {
  MFAActions,
  ThemeInterface,
  ToastStateProvider,
  WidgetProvider,
  theme as WidgetTheme,
  widgetDispatch,
} from '@eCommerce/frontend-legacy-shared-library';
import {ITheme, NativeBaseProvider} from 'native-base';
import React, {ReactNode} from 'react';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {BrowserRouter} from 'react-router-dom';

import './fonts';

export const MFAWidgetTheme = {
  ...WidgetTheme,
  fonts: {
    heading: 'Montserrat',
    body: 'Open Sans',
    mono: 'Open Sans',
  },
} as unknown as ThemeInterface;

MFAWidgetTheme.fontConfig = undefined;

const ProviderWrapper = ({children}: {children: ReactNode}) => {
  // FIXME: we probably want to set something up like rewards so that we can change this
  const BASE_URL = 'https://stage4.caesars.com';
  return (
    <BrowserRouter basename="/a/verification">
      <NativeBaseProvider theme={MFAWidgetTheme as unknown as ITheme}>
        <WidgetProvider
          onLogout={() => {}}
          onTimeout={() => {}}
          onLogin={() => {}}
          onUserChange={() => {
            widgetDispatch(MFAActions.getSecurityProfile());
          }}
          isLegacyMyRewards={false}
          baseUrl={BASE_URL}
          theme={MFAWidgetTheme}
        >
          <ToastStateProvider>
            <SafeAreaProvider>{children}</SafeAreaProvider>
          </ToastStateProvider>
        </WidgetProvider>
      </NativeBaseProvider>
    </BrowserRouter>
  );
};

export default ProviderWrapper;
